import { render } from "./NodeRedApp.vue?vue&type=template&id=2adfb918&ts=true"
import script from "./NodeRedApp.vue?vue&type=script&lang=ts"
export * from "./NodeRedApp.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__